<template>
  <div class="brand-good-list">
    <!-- 面包屑 -->
    <el-breadcrumb separator-class="el-icon-arrow-right" class="crumbs">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <!-- <el-breadcrumb-item :to="{ path: '/brandList' }">品牌</el-breadcrumb-item>
      <el-breadcrumb-item>{{$route.query.brandName}}</el-breadcrumb-item> -->
    </el-breadcrumb>
    <!-- 类目-类目-产品 -->
    <!-- <category-tree :categoryTree="categoryTree"
                   :choosedMenu="choosedMenu"
                   @changeChoosed="changeChoosed">
    </category-tree> -->
    <!-- 商品列表 -->
    <good-list :goodsList="goodList"
               :currentPage="currentPage"
               :pageSize="pageSize"
               :total="total"
               @handleCurrentChange="changePage">
    </good-list>
  </div>
</template>
<script>
import GoodList from './goodList'
// import CategoryTree from './categoryTree'
export default {
  data () {
    return {
      choosedMenu: '', // 已选中的类目
      categoryTree: [], // 类目层级树
      goodList: [], // 商品列表
      currentPage: 1,
      pageSize: 20,
      total: 0
    }
  },
  components: {
    GoodList
    // CategoryTree
  },
  computed: {
    activityId () {
      return this.$router.query.activityId
    },
    groupId () {
      return this.$router.query.groupId
    }
  },
  mounted () {
    // this.getCategoryTree()
    this.getDataList(1)
  },
  methods: {
    // 改变当前页
    changePage (val) {
      // this.currentPage = val
      this.getDataList(val)
    },
    // 获取分页数据
    getCategoryTree () {
      this.categoryTree = []
      this.$request.get(`/product/businessBrandDetails/categorybyBrand/${this.$route.query.brandName}`)
        .then(data => {
          if (data.code === 0) {
            this.categoryTree = data.data || []
          }
        })
        .catch(() => {
        })
    },
    // 获取列表数据
    getDataList (currentPage = this.currentPage) {
      // this.$http.get(`${window.SITE_CONFIG['baseURL']}/activity/activity/info/pc/${this.$route.query.activityId}`)
      // .then((data) => {
      //   if (data && data.result.code === 0) {
      //     let list = data.result.data.activitySpecialAreaVo || []
      //     let index = list.findIndex(item => {
      //       return (item.id + '') === this.$route.query.groupId
      //     })
      //     this.goodList = []
      //     if (index > -1) {
      //       this.goodList = list[index].activityCommodityVo || []
      //     }
      //   }
      // })
      this.goodList = []
      let params = {
        specialAreaCarouselId: this.$route.query.groupId
      }
      this.$http.post(`/front/order/special/activity/searchSpecialAreaCommodityList`, params)
        .then(({ data: res }) => {
          if (res.code === 0) {
            let list = res.data
            let goodList = []
            list.forEach(oneMenu => {
              if (oneMenu.activitySKUList && oneMenu.activitySKUList.length) {
                let json = {
                  ...oneMenu
                }
                let skuId = oneMenu.skuId
                oneMenu.activitySKUList.forEach(twoMenu => {
                  if (skuId === twoMenu.skuId) {
                    json.model = twoMenu.model
                  }
                })
                oneMenu.fileVoList.forEach(threeMenu => {
                  json.fileUrl = threeMenu.fileUrl
                })
                goodList.push(json)
              }
            })
            this.goodList = goodList
            // let index = list.findIndex(item => {
            //   return (item.id + '') === this.$route.query.groupId
            // })
            // this.goodList = []
            // if (index > -1) {
            //   this.goodList = list[index].activityCommodityVo || []
            // }
          }
        })
      // this.$request.get(`/product/businessBrandDetails/findCommodityInfoAndCategoryStructurePage`, {
      //   params: {
      //     "page": currentPage,
      //     "limit": this.pageSize,
      //     "brandName": this.$route.query.brandName,
      //     "labelName": this.choosedMenu,
      //     "commodityName":"",
      //     "detailFlag": false
      //   }
      // })
      //   .then(data => {
      //     if (data.data && data.data.code === 0) {
      //       this.currentPage = currentPage
      //       this.goodList = data.data.data || []
      //       this.total = data.data.count || 0
      //     }
      //   })
      //   .catch(err => {
      //     this.imgSrc = 'static/img/404.jpg'
      //   })
    },
    // 改变选中类目值
    changeChoosed (val) {
      if (this.choosedMenu !== val) {
        this.choosedMenu = val
        this.getDataList(1)
      }
    }
  }
}
</script>
<style scoped lang="scss">
.brand-good-list{
  width: 1190px;
  margin: 0 auto;
  .crumbs{
    margin: 20px 0;
    /deep/ .is-link:hover{
      color: #1D65A8;
    }
  }
}
</style>
